module.exports = __webpack_public_path__ + "img/icon_wy01.103fbc8a.png";